import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../../assets/erpsaude.png';
import { useHospital } from '../../contexts/HospitalContext';
import '../../App.css';

function toLabel(slug) {
  return slug.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}

export default function Home() {
  const { hospital } = useHospital();
  const hospitalLabel = toLabel(hospital);

  return (
    <main className="home-container">
      <div className="home-logo-wrap">
        <img src={Logo} alt="ERPSaúde" className="home-logo" />
        <span className="home-hospital-name">{hospitalLabel}</span>
      </div>

      <nav className="home-nav" aria-label="Painéis disponíveis">
        <Link to={`/${hospital}/triagem`} className="home-panel-btn">
          <strong>Triagem</strong>
          <small>Pacientes aguardando triagem inicial</small>
        </Link>
        <Link to={`/${hospital}/atendimento`} className="home-panel-btn">
          <strong>Atendimento</strong>
          <small>Pacientes aguardando atendimento</small>
        </Link>
      </nav>
    </main>
  );
}
